<template>
  <v-col cols="12">
    <v-divider></v-divider>
    <editor-menu-bar :editor="editor">
      <div
        class="editor-bar"
        align="center"
        slot-scope="{ commands, isActive }"
      >
        <v-btn icon @click="commands.bold">
          <v-icon>format_bold</v-icon>
        </v-btn>
        <v-btn icon @click="commands.italic">
          <v-icon>format_italic</v-icon>
        </v-btn>
        <v-btn icon @click="commands.strike">
          <v-icon>format_strikethrough</v-icon>
        </v-btn>
        <v-btn icon @click="commands.underline">
          <v-icon>format_underline</v-icon>
        </v-btn>
        <v-btn
          tile
          depressed
          elevation="0"
          @click="commands.heading({ level: 1 })"
        >
          <strong>h1</strong>
        </v-btn>
        <v-btn
          tile
          depressed
          elevation="0"
          @click="commands.heading({ level: 2 })"
        >
          <strong>h2</strong>
        </v-btn>
        <v-btn
          tile
          depressed
          elevation="0"
          @click="commands.heading({ level: 3 })"
        >
          <strong>h3</strong>
        </v-btn>
        <v-btn
          tile
          depressed
          elevation="0"
          @click="commands.heading({ level: 4 })"
        >
          <strong>h4</strong>
        </v-btn>
        <v-btn
          tile
          depressed
          elevation="0"
          @click="commands.heading({ level: 5 })"
        >
          <strong>h5</strong>
        </v-btn>
        <v-btn icon @click="commands.bullet_list()">
          <v-icon>format_list_bulleted</v-icon>
        </v-btn>
        <v-btn icon @click="commands.ordered_list()">
          <v-icon>format_list_numbered</v-icon>
        </v-btn>
        <v-btn icon @click="commands.blockquote()">
          <v-icon>format_quote</v-icon>
        </v-btn>
        <v-menu
          :close-on-content-click="false"
          style="max-width: 200px"
          content-class="emoji_select"
          right
          :offset-y="true"
        >
          <template v-slot:activator="{ on }">
            <button icon tile elevation="0" v-on="on">😃</button>
          </template>
          <div class="text-center pa-2" id="emoji-picker">
            <v-btn
              icon
              small
              v-for="(emoji, i) in emojis"
              :key="i"
              @click="addEmoji(emoji.text)"
              class=""
            >
              <span class="emoji-item">{{ emoji.text }}</span>
            </v-btn>
          </div>
        </v-menu>
      </div>
    </editor-menu-bar>
    <editor-content :editor="editor" class="wysiwyg-content hasPicked" />
  </v-col>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
  Bold,
  Italic,
  Link,
  Strike,
  Underline,
  Heading,
  ListItem,
  BulletList,
  Blockquote,
  OrderedList,
} from "tiptap-extensions";

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  components: {
    EditorContent,
    EditorMenuBar,
  },
  data: () => {
    return {
      editor: null,
      emojis: [
        { text: "😃" },
        { text: "😉" },
        { text: "😋" },
        { text: "😎" },
        { text: "😍" },
        { text: "🙄" },
        { text: "😑" },
        { text: "🤔" },
        { text: "😥" },
        { text: "🤐" },
        { text: "😫" },
        { text: "😲" },
        { text: "😭" },
        { text: "😡" },
        { text: "😬" },
        { text: "😴" },
      ],
    };
  },
  mounted() {
    this.editor = new Editor({
      extensions: [
        new Bold(),
        new Italic(),
        new Link(),
        new Strike(),
        new Underline(),
        new Heading(),
        new ListItem(),
        new BulletList(),
        new Blockquote(),
        new OrderedList(),
      ],
      content: this.value,
      parseOptions : {
        preserveWhitespace: true
      }
    });
    this.editor.on("update", (editor) => {
      this.$emit("input", editor.getHTML());
      this.$emit("input-raw", editor.getHTML().replace(/<\/?[^>]+(>|$)/g, ""));
    });
  },
  beforeUnmount() {
    this.editor.destroy();
  },
  methods: {
    addEmoji(emoji) {
      const transaction = this.editor.state.tr.insertText(emoji);
      this.editor.view.dispatch(transaction);
    },
  },
  computed: {
    message: {
      set(message) {
        // console.info(message);
        this.$emit("input", message);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    value: function (value) {
      this.editor.setContent(value, false);
    },
  },
};
</script>

<style lang="scss">
#emoji-picker {
  background-color: white;
  max-width: 200px;
  .emoji-item {
    font-size: 18px;
    color : black !important;
  }
}

.hasPicked {
  margin-bottom: 10px;
}
</style>